import propTypes from 'prop-types';
import { CardBody, Card } from 'reactstrap';
import { FormikProvider } from 'formik';
import { useTranslation } from 'react-i18next';
import { Title, Subtitle } from '../Login/styles';
import RenewPasswordForm from './RenewPasswordForm';
import { Container } from './styles';

const RenewPassword = ({ formikBag, mfaCodeRequired }) => {
  const [t] = useTranslation('renew-password');
  return (
    <FormikProvider value={formikBag}>
      <Container>
        <Card>
          <CardBody>
            <Title>{t('title')}</Title>
            <Subtitle>{t('subtitle')}</Subtitle>
            <RenewPasswordForm mfaCodeRequired={mfaCodeRequired} />
          </CardBody>
        </Card>
      </Container>
    </FormikProvider>
  );
};

export default RenewPassword;

RenewPassword.propTypes = {
  formikBag: propTypes.object.isRequired,
  mfaCodeRequired: propTypes.bool,
};

RenewPassword.defaultProps = {
  mfaCodeRequired: false,
};
